<template>
	<Container>
		<TopBar class='tabbr'/>
		<h2 v-if='article.Title' class="article-title">{{article.Title}}</h2>
		<Video v-if='isLocalVideo' v-else class='video' @onPlayEnded='onPlayEnded' :seekable='true' :src='article.Link' :pic='article.Pic'/>
		<div v-else  class="content" v-html='article.Content'></div>
		
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import Video from '@/components/common/Video'
	import {observeMixin} from '@/components/common/mixin'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				article:{},
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			'$route'(value){
				this.initData()
			},
		},
		mixins:[observeMixin],
		components: {
			TopBar,
			Video
		},
		computed: {
			...mapState({

			}),
			isLocalVideo(){
				return this.article.MediaType.toLowerCase() == 'video' && this.article.Link.indexOf('http://doterra-videos') != -1
			}
		},
		methods: {
			...mapActions([
				'getCommunityArticleAction',
				'observeAction',
			]),
			playVideo(){
				console.log('playVideo')
			},
			async initData(){
				let Code = this.$route.query?.code
				this.article = await this.getCommunityArticleAction({Code})
				this.observe(Code)
			},
		},
	}
</script>

<style lang='scss' scoped>
	.article-title {
		max-width: 1200px;
		margin: auto;
		padding: 20px 0;
		width: 80vw;
		border-bottom: 1px solid #ccc;
	}
		.video {
			margin:30px auto;
			max-width: 1044px;
			max-height: 587px;
			width:70vw;
			height:40vw;
		}
	.content {
		width: 80vw;
		margin:auto;
	}
	@media (min-width:1200px ) {
		.tabbr {
			padding-left: calc(50% - 600px)
		}
	}
</style>